import { InsightsNavbar } from "@/components/InsightsNavbar";
import { AnimatedSection } from "@/components/AnimatedSection";
import { ScrollProgressIndicator } from "@/components/ScrollProgressIndicator";
import { Footer } from "@/components/Footer";
import { InsightsLeadModal } from "@/components/InsightsLeadModal";
import { InsightsBreadcrumb } from "@/components/InsightsBreadcrumb";
import { AiCodingHeroSection } from "@/components/insights/ai-coding/AiCodingHeroSection";
import { AiCodingTakeaway } from "@/components/insights/ai-coding/AiCodingTakeaway";
import { AiCodingFounderQuote } from "@/components/insights/ai-coding/AiCodingFounderQuote";
import { AiCodingComparison } from "@/components/insights/ai-coding/AiCodingComparison";
import { AiCodingUseCases } from "@/components/insights/ai-coding/AiCodingUseCases";
import { InsightEngagementTracker } from "@/components/InsightEngagementTracker";
import { RelatedTools } from "@/components/RelatedTools";
import { InsightFAQSection } from "@/components/InsightFAQSection";
import { InsightBenchmarks } from "@/components/InsightBenchmarks";
import { TableOfContents } from "@/components/TableOfContents";

const AiCodingAssistants = () => {
  return (
    <>
      <InsightEngagementTracker slug="ai-coding-assistants" title="AI Coding Assistants" />
      <InsightsNavbar showBack />
      <ScrollProgressIndicator />
      <TableOfContents />
      <InsightsLeadModal />
      <main className="page-container pb-16 sm:pb-20">
        <InsightsBreadcrumb category="AI Development" currentPage="AI Coding Assistants" />
        <AiCodingHeroSection />
        <AnimatedSection delay={100} className="mt-10 sm:mt-12"><AiCodingTakeaway /></AnimatedSection>
        <AnimatedSection delay={50} className="mt-8 sm:mt-10"><AiCodingFounderQuote /></AnimatedSection>
        <div className="section-divider" />
        <AnimatedSection delay={0}><AiCodingComparison /></AnimatedSection>
        <AnimatedSection delay={0}><AiCodingUseCases /></AnimatedSection>
        <AnimatedSection delay={0}><InsightBenchmarks insightSlug="ai-coding-assistants" /></AnimatedSection>
        <AnimatedSection delay={0}><InsightFAQSection insightSlug="ai-coding-assistants" /></AnimatedSection>
        <AnimatedSection delay={0}><RelatedTools insightSlug="ai-coding-assistants" /></AnimatedSection>
      </main>
      <Footer />
    </>
  );
};

export default AiCodingAssistants;
